import { trimPipes, milOrBil, sanitize, isEmpty } from "../../_js/common/_util";

'use strict';

export default class Homepage {
    constructor() { }

    generateHomepageHTML(el) {
        let homepageHTML = '';

        homepageHTML +=
        `<main>
            <div class="homepage-banner">
                <div class="homepage-banner-content">
                    <div class="homepage-banner-left">
                        <h2 class="title"> Mapping China’s Tech Giants</h2>
                        <p class="body">
                            This multi-year project maps the overseas expansion of key Chinese technology companies. 
                        <br/>
                            <br/>
                            Launched in April 2019 and re-launched in June 2021 this website now includes 27 companies and 3800+ entries. Each entry is populated with up to 15 categories of data, totalling 38000+ data points.                        </p>
                        
                        <div class="leftBtn">
                        <a class="homepageBtn" href='#/map/'>Explore Map<a/>
                        <a class="homepageBtn" href='#/data/'>Explore Data<a/>
                        </div>
                    </div>
                    <div class="homepage-banner-right">
                        <a href="#/analysis/">
                            <div class="analysis">
                                <span>8+</span>Research Products
                                <div class="plus-icon">+</div>
                            </div>
                        </a>
                        <a href="#/companies">
                            <div class="companies">
                                <span>27</span>Tech Companies
                                <div class="plus-icon">+</div>
                            </div>
                        </a>
                        <a href="#/map/">
                            <div class="overseas-presence">
                                <span>3800+</span>entries
                                <div class="plus-icon">+</div>
                            </div>
                        </a>
                        <a href="#/data/">
                            <div class="data-points">
                                <span>186</span>Countries and Territories
                                <div class="plus-icon">+</div>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="homepage-banner-background">

                </div>
            </div>

            <div class="homepage-slides">
            </div>

            <div class="homepage-explore-highlights">
                <div class="homepage-explore-highlights__header">
                    <h2>Explore highlights</h2>
                </div>
                <div class="homepage-explore-highlights__body">
                    <div class="homepage-explore-highlights__body__left">
                        <div class="homepage-explore-highlights__body__left__top">
                            <img src="/assets/chi-tech/images/background-map.jpg"></img>
                        </div>
                        <div class="homepage-explore-highlights__body__left__bottom">
                            <div class="type make-dev-clickable" onclick="window.open('https://www.aspistrategist.org.au/china-tech-giants-map-update-3-launch-major-updates','mywindow');"> The Strategiest</div>
                            <div class="title make-dev-clickable" onclick="window.open('https://www.aspistrategist.org.au/china-tech-giants-map-update-3-launch-major-updates','mywindow');"> China Tech Map Relaunched with Major Updates</div>
                            <div class="author-link-wrap">
                                <div class="author">By Samantha Hoffman</div>
                                <a href="https://www.aspistrategist.org.au/china-tech-giants-map-update-3-launch-major-updates" class="link" target="_blank" rel="noopener noreferrer">link
                                    <i aria-hidden="true"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="homepage-explore-highlights__body__right">
                        <div class="homepage-explore-highlights__body__right__item">
                            <div class="homepage-explore-highlights__body__right__item__left">
                                <img src="/assets/chi-tech/images/analysis-img.png">

                            </div>
                            <div class="homepage-explore-highlights__body__right__item__right">
                                <div class="title make-dev-clickable" onclick="location.href='#/analysis/articles';" >Our Articles</div>
                                <div class="body make-dev-clickable" onclick="location.href='#/analysis/articles';">Read more of our analysis on issues and events surrounding the companies and topics covered in our Mapping China’s Tech Giants project. Click here to see more regularly updated content.</div>
                                <a class="/" style="text-decoration: none;" href='#/analysis/articles' >link</a>
                            </div>
                        </div>

                        <div class="homepage-explore-highlights__body__right__item">
                            <div class="homepage-explore-highlights__body__right__item__left">
                                <img href="#/analysis/#articles" src="/assets/chi-tech/images/coverage-img.png">

                            </div>
                            <div class="homepage-explore-highlights__body__right__item__right">

                                <div class="title make-dev-clickable" onclick="location.href='#/analysis/snapshots';">Thematic Snapshots</div>
                                <div class="body make-dev-clickable" onclick="location.href='#/analysis/snapshots';" >Key policy issues and why they matter. Click here to download a single document for each topic.</div>
                                <a class="/" style="text-decoration: none;" href="#/analysis/snapshots">link</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div class="homepage-our-policy">
                <div class="homepage-our-policy__content">
                    <div class="homepage-our-policy__header">
                        <h2>Explore our policy briefs</h2>
                    </div>
                    <div class="homepage-our-policy__body">
                        <div class="policy-card">
                            <div class="type">
                                POLICY BRIEF
                            </div>
                            <div class="title make-dev-clickable" onclick="window.open('https://www.aspi.org.au/report/mapping-chinas-technology-giants-reining-chinas-technology-giants','mywindow');" >
                            Reining in China’s Technology Giants <sup>New</sup>
                            </div>
                            <div class="author-link-wrap">
                                <div class="author">
                                Fergus Ryan, Audrey Frtiz & Daria Impiombato
                                                                </div>
                                <a href="https://www.aspi.org.au/report/mapping-chinas-technology-giants-reining-chinas-technology-giants" class="link" target="_blank" rel="noopener noreferrer">
                                    link
                                </a>
                            </div>
                        </div>
                        <div class="policy-card">
                            <div class="type">
                                POLICY BRIEF
                            </div>
                            <div class="title make-dev-clickable" onclick="window.open('https://www.aspi.org.au/report/mapping-chinas-tech-giants-supply-chains-and-global-data-collection-ecosystem','mywindow');">
                                Mapping China's Tech Giants: Supply Chains and the Global Data Collection Ecosystem <sup>New</sup>
                            </div>
                            <div class="author-link-wrap">
                                <div class="author">
                                Dr Samantha Hoffman and Dr Nathan Attrill
                                                                </div>
                                <a href="https://www.aspi.org.au/report/mapping-chinas-tech-giants-supply-chains-and-global-data-collection-ecosystem" class="link" target="_blank" rel="noopener noreferrer">
                                    link
                                </a>
                            </div>
                        </div>
                        <div class="policy-card">
                            <div class="type">
                                POLICY BRIEF
                            </div>
                            <div class="title make-dev-clickable" onclick="window.open('https://www.aspi.org.au/report/mapping-more-chinas-tech-giants','mywindow');" >
                                Mapping <em>more</em> of China's tech giants: AI and surveillance
                            </div>
                            <div class="author-link-wrap">
                                <div class="author">
                                    Danielle Cave, Fergus Ryan & Vicky Xiuzhong Xu
                                </div>
                                <a href="https://www.aspi.org.au/report/mapping-more-chinas-tech-giants" class="link" target="_blank" rel="noopener noreferrer">
                                    link
                                </a>
                            </div>
                        </div>
                        <div class="policy-card">
                            <div class="type">
                                POLICY BRIEF
                            </div>
                            <div class="title make-dev-clickable" onclick="window.open('https://www.aspi.org.au/report/mapping-chinas-tech-giants','mywindow');">
                                Mapping China’s Tech Giants
                            </div>
                            <div class="author-link-wrap">
                                <div class="author">
                                    Danielle Cave, Dr Samantha Hoffman, Alex Joske, Fergus Ryan & Elise Thomas
                                </div>
                                <a href="https://www.aspi.org.au/report/mapping-chinas-tech-giants" class="link" target="_blank" rel="noopener noreferrer">
                                    link
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="homepage-our-policy__background">
                </div>
            </div>


        </main>`;

        return homepageHTML;
    }
}
